@if (this.usage.length === 0) {
<span
  class="text-muted small"
  i18n="@@skill-usage-none"
>Keiner Stage zugeordnet</span>
} @else {
<div class="d-flex flex-wrap gap-1">
  @for (hit of this.usage; track hit.stageId) {
  <a
    class="skill-usage-chip"
    [routerLink]="['/', 'bot-admin', this.rss.botConfig._id, 'stage-manager']"
    [queryParams]="{ openStage: hit.stageId }"
  >
    <i class="ri-stack-fill"></i>{{ hit.title }}
  </a>
  }
</div>
}
